import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../client';
import type { CategoryMeta, SmartFilterId, SystemCategoryId } from 'markcat-domain';

export interface BookmarkSummary {
  category_counts: Record<string, number>;
  system_counts: Record<SystemCategoryId, number>;
  smart_filter_counts: Record<SmartFilterId, number>;
  tag_counts: Record<string, number>;
  total_count: number;
}

export const CATEGORY_META_QUERY_KEY = ['category-meta'] as const;
export const BOOKMARK_SUMMARY_QUERY_KEY = ['bookmark-summary'] as const;

export function useCategoryMeta() {
  return useQuery({
    queryKey: CATEGORY_META_QUERY_KEY,
    queryFn: () => apiFetch<CategoryMeta[]>('/api/category-meta'),
  });
}

export function useBookmarkSummary() {
  return useQuery({
    queryKey: BOOKMARK_SUMMARY_QUERY_KEY,
    queryFn: () => apiFetch<BookmarkSummary>('/api/bookmark-summary'),
  });
}
